import React from 'react';
import { useTranslation } from 'react-i18next';
import GradientBorder from '../GradientBorder/GradientBorder';
import './HowToPlay.scss';

const HowToPlay = () => {
  const { t } = useTranslation();
  return (
    <GradientBorder name={`how-to-play-border`}>
      <div className='how-to-play'>
        <h2 className='how-to-play__header'>{t('how-to-play')}</h2>
        <div className='how-to-play__content'>
          <ol>
            <li key='1'>{t('select-a-winner-for-each-race')}</li>
            <li key='2'>{t('track-your-progress')}</li>
          </ol>
        </div>
      </div>
    </GradientBorder>
  );
};

export default HowToPlay;
